import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tariffTitle',
    standalone: false
})
export class TariffTitlePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value === null) { return ''; }
    return this.mapTariff(value);
  }

  mapTariff(key) {

    switch (key) {
      case 'RESHN0001556197': // Prod RE Strom
      case 'RESHN0001553544': // AKZ RE Strom
        return 'Tarif für Heimatliebende';
      case 'RESHN0001555590': // Prod RE Strom
      case 'REGHN0000098275': // Prod RE Gas
      case 'RESHN0001553501': // AKZ RE Strom
      case 'REGHN0000097159': // AKZ RE Gas
      case 'REGHN0000097256': // AKZ RE Gas
      case 'RESGN0000463141': // GEWE Prod RE Strom
      case 'REGGN0000047709': // GEWE Prod RE Gas
      case 'SASGN0000000039': // GEWE Prod SWA Strom
      case 'SAGGN0000000004': // GEWE Prod SWA Gas
        return 'Tarif für Sicherheitsorientierte';
      case 'RESHG0000000475': // Prod RE Strom & Gas
      case 'REGHG0000000000': // Prod RE Gas
      case 'RESHG0000000471': // Akz RE Strom
      case 'RESGG0000000247': // GEWE Prod RE Strom
      case 'REGGG0000000000': // GEWE Prod RE Gas
        return 'Tarif für Freiheitsliebende';
      case 'REGHN0000098276': // Prod RE Gas
      case 'REGHN0000097172': // Akz RE Gas
      case 'REGHN0000097257': // Akz RE Gas
      case 'RESGN0000463142': // GEWE Prod RE Strom
      case 'REGGN0000047710': // GEWE Prod RE Gas
        return 'Tarif für Umweltbewusste';
      default:
        return 'Ihr Tarif';
    }
  }

}
